import http_request from './http_request'
import config from 'config'

function publishLesson(presentationId) {
	return http_request.put(`${config.api}presentation/${presentationId}/publish`)
		.send()
}

function enableLesson(presentationId) {
	return http_request.put(`${config.api}presentation/${presentationId}/undelete`)
		.send()
}

function getCustomSlides(presentationId) {
	return http_request.get(
		`${config.api}presentation/${presentationId}/custom_slides`
	).send()
}

export default {
	publishLesson,
	enableLesson,
	getCustomSlides,
}
